import script from "./FeedbackView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedbackView.vue?vue&type=script&setup=true&lang=ts"

import "./FeedbackView.vue?vue&type=style&index=0&id=b84cc708&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b84cc708"]])

export default __exports__